import React from "react";
import { Grid } from "../Grid";

interface Props {
  dataTestID: string;
  children?: React.ReactNode;
}

export const IconGridCard: React.FC<Props> = ({ dataTestID, children }) => {
  return (
    <Grid
      ml={[-3, -3, "-24px", "-24px"]}
      mb={[-3, -3, "-24px", "-24px"]}
      data-testid={dataTestID}
      grid={["100%", "100%", "50%", "50%", "50%"]}
      pt="24px"
    >
      {children}
    </Grid>
  );
};
